import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    DISPLAY_MODE_STANDARD,
    DISPLAY_MODE_PANEL,
    PANEL_DISPLAY_RIGHT,
    PANEL_DISPLAY_LEFT,
    DISPLAY_MODE_FULL_SCREEN,
    DISPLAY_MODE_FORM_INLINE,
} from 'common/entities/form/styleConfiguration/constants';

import { getFormDisplayStyles } from 'common/entities/form/styleConfiguration/selectors';

import Modal from './Modal';
import FullScreen from './FullScreen';
import Slide from './Slide';
import Loader from './Loader';

import { getSplashPageFormOpen, getSplashPageFormLoading, closeModal, getFormId } from '../../modules/splashPage';

const formRendererWrappers = {
    [DISPLAY_MODE_PANEL]: (props) => <Slide {...props} />,
    [DISPLAY_MODE_FULL_SCREEN]: (props) => <FullScreen {...props} />,
    [DISPLAY_MODE_STANDARD]: (props) => <Modal {...props} />,
    [DISPLAY_MODE_FORM_INLINE]: (props) => <Loader {...props} />,
};

const Container = ({ children, displayMode, isInline, ...restProps }) => {
    const formType = isInline ? DISPLAY_MODE_FORM_INLINE : displayMode;
    const FormRendererWrapper = formRendererWrappers[formType];

    return FormRendererWrapper({ children, ...restProps });
};

Container.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    isInline: PropTypes.bool.isRequired,
    open: PropTypes.bool,
    loading: PropTypes.bool,
    onRequestClose: PropTypes.func.isRequired,
    displayMode: PropTypes.oneOf([DISPLAY_MODE_STANDARD, DISPLAY_MODE_PANEL, DISPLAY_MODE_FULL_SCREEN]),
    panelDisplay: PropTypes.oneOf([PANEL_DISPLAY_RIGHT, PANEL_DISPLAY_LEFT]),
};

Container.defaultProps = {
    open: false,
    loading: false,
    displayMode: DISPLAY_MODE_STANDARD,
    panelDisplay: PANEL_DISPLAY_LEFT,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);

    const { displayMode, panelDisplay } = getFormDisplayStyles(state, formId);

    return {
        open: getSplashPageFormOpen(state),
        loading: getSplashPageFormLoading(state),
        displayMode,
        panelDisplay,
    };
};

const mapDispatchToProps = {
    onRequestClose: closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
